<script setup>
import Navbar from "@/components/Navbars/AuthNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import {UploadFilled} from '@element-plus/icons-vue'
//axios请求
import {inject} from 'vue'

const $axios = inject('$axios')
import team1 from "@/assets/img/team-1-800x800.jpg";
import team2 from "@/assets/img/team-2-800x800.jpg";
import team3 from "@/assets/img/team-3-800x800.jpg";
import team4 from "@/assets/img/team-4-470x470.png";

import {ref} from "vue";
import {ElLoading} from "element-plus";

const species = ref('')
const type = ref('')


let uploadFile = ref()

function onUploadChange(file) {
  //获取文件
  uploadFile.value = file
}

// 阻止默认上传，解决控制台报错
function beforeAvatarUpload(file) {
  return false // 屏蔽了action的默认上传
}


// 点击确定发送请求 接口要求传fromdata类型的数据
function blast() {
  const loadingInstance = ElLoading.service({
    fullscreen: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)',
    lock: true
  })
  let formData = new FormData()
  //在onUploadChange里拿到了文件存到data里，这里取出来，记得要取文件的raw
  formData.append('file', uploadFile.value.raw)
  $axios({
    url: `http://bioinfo-gdut.com:8000/api/blast`,
    method: 'post',
    // 添加headers说明数据类型
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    params: {
      species: species.value,
      type: type.value,
      // query参数，token是全局变量，直接从localStorage里取
      access_token: localStorage.getItem('token')
    },
    data: formData,
    responseType: 'blob' // 表明返回服务器返回的数据类型
  }).then(resp => {
    loadingInstance.close()
    var res = JSON.parse(JSON.stringify(resp.headers))
    if (res['content-type'] === 'application/txt') {
      let url = window.URL.createObjectURL(new Blob([resp.data], {type: "application/txt;charset=utf-8"}));
      const link = document.createElement("a");
      link.href = url
      link.download = ""
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      console.log(url)
    } else {
      fullscreenLoading.value = false
      ElMessage({
        dangerouslyUseHTMLString: true,
        showClose: true,
        message: '<p>Sorry,Some samples are missing corresponding data.</p>',
        type: 'error',
        center: true,
      })
    }
  })

}
</script>
<template>
  <div>
    <navbar/>
    <main>
      <div
          class="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75"
      >
        <div
            class="absolute top-0 w-full h-full bg-center bg-cover"
            style="
            background-image: url('https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2710&q=80');
          "
        >
          <span
              id="blackOverlay"
              class="w-full h-full absolute opacity-75 bg-black"
          ></span>
        </div>
        <div class="container relative mx-auto">
          <div class="items-center flex flex-wrap">
            <div class="w-full lg:w-8/12 px-4 ml-auto mr-auto text-center">
              <div class="pr-12">
                <h1 class="text-white font-semibold text-5xl">
                  Start Your Blast !
                </h1>
                <p class="mt-4 text-lg text-blueGray-200" style="text-align: justify">
                  This function can perform blast alignment for each species of Cinnamomum, select the species name on the left, and select the nucleic acid (blastn) or protein (blastp) sequence of that species on the right. Then drag in your own .fasta/.txt file for alignment, and a .txt  file will be returned after the alignment.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
            class="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
            style="transform: translateZ(0);"
        >
          <svg
              class="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
          >
            <polygon
                class="text-blueGray-200 fill-current"
                points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
      </div>
      <section class="relative py-16 bg-blueGray-200">
        <div class="container mx-auto px-4">
          <div
              class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg -mt-64"
          >
            <div class="px-6">
              <div class="text-center mt-12 d-flex flex-column">
                <div class="d-flex flex-row justify-content-center">
                  <select class="form-select form-select-lg mx-4" aria-label=".form-select-lg example" v-model="species"
                          style="width: 28%; color: #ccc;">
                    <option value="" disabled selected hidden>Select your specie</option>
                    <option value="Cinnamomum_burmannii" style="color: black;">Cinnamomum burmannii</option>
                    <option value="Cinnamomum_camphora" style="color: black;">Cinnamomum camphora</option>
                    <option value="Cinnamomum_chago" style="color: black;">Cinnamomum chago</option>
                    <option value="Cinnamomum_kanehirae" style="color: black;">Cinnamomum kanehirae</option>
                    <option value="Cinnamomum_parthenoxylon" style="color: black;">Cinnamomum parthenoxylon</option>
                    <option value="Cinnamomum_tenuipile" style="color: black;">Cinnamomum tenuipile</option>
                    <option value="Cinnamomum_verum" style="color: black;">Cinnamomum verum</option>
                    <option value="Laurus_nobilis" style="color: black;">Laurus nobilis</option>
                    <option value="Lindera_glauca" style="color: black;">Lindera glauca</option>
                    <option value="Litsea_cubeba" style="color: black;">Litsea cubeba</option>
                    <option value="SwissProt" style="color: black;">SwissProt</option>
                  </select>
                  <select class="form-select form-select-lg mx-4" aria-label=".form-select-lg example" v-model="type"
                          style="width: 20%; color: #ccc;">
                    <option value="" disabled selected hidden>Gene or Protein</option>
                    <option value="gene" style="color: black;">Gene</option>
                    <option value="protein" style="color: black;">Protein</option>
                  </select>
                  <button
                      class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      @click="blast">
                    Analyse
                  </button>
                </div>
                <div>
                  <div class="d-flex justify-content-center py-3 mb-4">
                    <el-upload
                        ref="upload"
                        accept=".fasta,.txt"
                        action="#"
                        :auto-upload="false"
                        :limit="1"
                        :on-change="onUploadChange"
                        :before-upload="beforeAvatarUpload"
                        style="width:60%;display: inline-block"
                        class="upload-demo"
                        drag
                        multiple
                    >
                      <el-icon class="el-icon--upload">
                        <upload-filled/>
                      </el-icon>
                      <div class="el-upload__text">
                        Drop file here or <em>click to upload</em>
                      </div>
                      <template #tip>
                        <div class="el-upload__tip">
                          jpg/png files with a size less than 500kb
                        </div>
                      </template>
                    </el-upload>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <footer-component/>
  </div>
</template>
